import { render, staticRenderFns } from "./ImageOption.vue?vue&type=template&id=0a12bc22&scoped=true&"
import script from "./ImageOption.vue?vue&type=script&lang=js&"
export * from "./ImageOption.vue?vue&type=script&lang=js&"
import style0 from "./ImageOption.vue?vue&type=style&index=0&id=0a12bc22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a12bc22",
  null
  
)

export default component.exports